import "./CAV.css"
import {Row,Col,Card, Container} from "react-bootstrap"
import {Link} from "react-router-dom"
const CAV = () =>{
    return <div style={{padding:"2%"}}>   
    <h1>CAV</h1>
    <ul className="flex-container">
    <li className = "flex-item" style={{width:"40rem"}}>

    <p>CAV is a utility module capable of performing most of your essential tasks in one package. 
      </p>
      <p>It contains 2 units. One unit can:</p>
      <ul>
          <li>Crossfade</li>
          <li>Attenuvert</li>
          <li>Attenuate</li>
          <li>Bipolar Voltage Source</li>
      </ul>
      <br></br>
      <p>The module contains 2 of these units chained together, with a 3rd output which sums the outputs together. This expands the possibilities greatly! to name a few:</p>
      <ul>
          <li>Modulate and DC Offset</li>
          <li>Mix 2 signals</li>
          <li>Cross mix 3 signals</li>
          <li>Combine 4 signals</li>
          <li>Subtract signals: convert LP to HP, or phase subtractive synthesis </li>
          <li>Mono to stereo convertor w/ panning and "out of phase" capabilities</li>
          <li>Amplify a signal up to 2x</li>
      </ul>
        <br/>
      <br/>
      <div>
      <h2>Details</h2>
      <p>2 Active Manual Crossfader Units</p>
      <p>6HP</p>
      <p>Accepts AC and DC input</p>
      <p>Active with protective output buffers</p>
      <p>2 LED sliders with 45mm travel for tactile and precise control</p>
      </div>
      </li>
      <li className = "flex-item" style={{width:"40rem"}}>
        <img src={require("./CAV.jpg")} style={{width:"100%"}}></img>
      </li>
      </ul>

      <h2>How to Use</h2>
      <p>A unit has 2 inputs labelled <b>vert</b>, and <b>ate</b>.
       Representing the behaviour of the unit when a jack is inserted into only that input (attenu<b>vert</b>, and attenu<b>ate</b>).
        The vert input works by crossfading the input with it's inversion and it is considered the primary input due too it's versatility</p>

      <p>When no input is inserted into vert, It's normalled to the voltage reference, turning the module into a control voltage source</p>
      <p>The vert input of the second unit is normalled to the vert input of the first.</p>



      {/* <p>CAV consists of 2 units. A unit has 2 inputs and one output. The behaviour of a unit is dependant on which inputs have been inserted. The main behaviours are:</p>  
        <ul>
        <li>Both inputs: linearly crossfade signals</li>
        <li>Only input 1: Attenuvert the signal (crossfading the positive signal with it's inversion which is normalled to 2) </li>
        <li>No input: A voltage source </li>
        </ul>  
    <br></br> */}
    <p>Unit 1 is denoted by A, B, and AXB for input 1, input 2, and the output respectively</p>
    <p>Unit 2 is denoted by C, D, and CXD for input 1, input 2, and the output respectively</p>
    <p>The output marked + is the sum of AXB and CXD</p>

      
      {/* <h2>Recipes</h2>
      <p></p> */}

      <h2>Some extra details</h2>
      <p>
        The first run of commercial modules (V3.3) had a bug on the board which limited the range of the voltage source to +-2.5V
      </p>
      <p>
        The module is active and provides all the benefits that come with that. The output buffers include protection against accidental grounding and prevents drooping when connected directly to multiple inputs!
      </p>
      <p>Their are some light behavioural customisation options for advanced usage, this page and build guide assume the recommended setup.</p>
      <p>All outputs and some some inputs all exposed for connecting to other modules (or another CAV ;) to create some semi-modualar experience</p>

      <h2>DIY</h2>
      <p>CAV comes SMD pre-soldered, The instructions to finish it are in the <Link to = "/CAV/build">Build Guide</Link>
  </p>

      <table>
        <tr>
        <th>Name</th>
        <th>Quantity  
        </th>
        <th>Mandatory
        </th>
        </tr>
        <tr>
          <td>Mono 3.5mm Jacks (thonkiconn)</td>
          <td>7</td>
          <td>Yes</td>
        </tr>
        <tr>
          <td>shrouded 2x5 pin header</td>
          <td>
            1
          </td>
          <td>
            Yes
          </td>
         
        </tr>
        <tr>
          <td>
              PTL45: 45mm LED slider
          </td>
          <td>
            2
          </td>
          <td>
            Yes
          </td>
          
        </tr>
        <tr>
          <td>M2 Screws</td>
          <td>4</td>
          <td>Yes</td>
        
        </tr>
        <tr>          
          <td>M2 spacers</td>
          <td>4</td>
          <td>No</td>

        </tr>
        <tr>
          <td>2.54mm box pin headers</td>
          <td>11</td>
          <td>No</td>
          
        </tr>
        <tr>
        <td>1x2 2.54mm header jumpers </td>
        <td>3</td>
        <td>No</td>
        
        </tr>
        <tr>
          <td>
          Ferrite bead
          </td>
          <td>2</td>
          <td>No</td>
        
        </tr>
      </table>
          <br></br>
          <h2>Links</h2>
          <h3><Link to = "/CAV/build">Build Guide</Link></h3>
          <h3><a href = "/CAV_ibom.html">BOM</a></h3>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
    </div>
}

export default CAV